import { forwardRef as commonForwardRef } from "packages/react";

export const forwardRef = commonForwardRef;
